import { ThemePreferencesPanel } from '@jarvis/platform-ui';
import { useThemeStore } from '../../theme/useThemeStore';

export function SettingsAppearancePage() {
  return (
    <div className="user-settings-sections">
      <ThemePreferencesPanel useThemeStore={useThemeStore} />
    </div>
  );
}
